module.exports = __webpack_public_path__ + "edit.png?1db23b72092ad6ecbee41eb083828fe6";